import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';
import { Button } from './ui/button';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

export const RequestNoActionForm = ({ request, machineryId, onBack, onDone }) => {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`${API}/maintenance-requests/${request.id}/acknowledge-only`, {
        note: note.trim() || null,
        machinery_id: machineryId || null,
      });
      toast.success('Request acknowledged · no action needed');
      onDone();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to acknowledge request');
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="ack-no-action-form">
      <p className="text-sm text-slate-700">No work order, maintenance log or follow-up will be created.</p>
      <div className="space-y-1">
        <Label htmlFor="ack-no-action-note">Note (optional)</Label>
        <Textarea id="ack-no-action-note" data-testid="ack-no-action-note" rows={3} maxLength={2000}
          placeholder="e.g. Duplicate of yesterday's request, or checked with operator — reading is normal"
          value={note} onChange={(e) => setNote(e.target.value)} />
      </div>
      <div className="flex justify-end gap-2">
        <Button type="button" variant="outline" onClick={onBack} disabled={saving} data-testid="ack-no-action-back">Back</Button>
        <Button type="submit" disabled={saving} data-testid="ack-no-action-submit">
          {saving ? 'Saving…' : 'Acknowledge'}
        </Button>
      </div>
    </form>
  );
};
